import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IPyramidalShareholderListState } from '../states/pyramidal-shareholder-list.state';

export const selectPyramidalShareholderListState = createFeatureSelector<IPyramidalShareholderListState>('pyramidalShareholderList');

export const selectPyramidalShareholderSearchFilter = createSelector(
  selectPyramidalShareholderListState,
  (state: IPyramidalShareholderListState) => state.searchFilter
);

export const selectPyramidalShareholderPagination = createSelector(
  selectPyramidalShareholderListState,
  (state: IPyramidalShareholderListState) => ({
    currentPage: state.currentPage,
    pageSize: state.pageSize
  })
);

export const selectPyramidalShareholderSort = createSelector(
  selectPyramidalShareholderListState,
  (state: IPyramidalShareholderListState) => ({
    sortBy: state.sortBy,
    ascending: state.ascending
  })
);

export const selectPyramidalShareholderListFullState = createSelector(
  selectPyramidalShareholderListState,
  (state: IPyramidalShareholderListState) => state
);
